export default "__VITE_ASSET__f1ec7cfa__"